export const getApiMethods = (appUrl) => {
    return [
        {
            name: 'PlayerUpdate',
            method: appUrl + '/users/register',
            action: 'post',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            args: [
                {
                    name: 'form_submitted',
                    processArgs: (val) => {
                        return 1;
                    },
                },
                {
                    name: 'new',
                    processArgs: (val) => {
                        return 1;
                    },
                },
                {
                    name: 'country',
                    processArgs: (val) => {
                        return 'US';
                    },
                },
                {
                    name: 'first_name',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'last_name',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'email',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'email_confirm',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'address1',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'address2',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'city',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'state',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'zip',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'area_phone1',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'prefix_phone1',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'suffix_phone1',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'area_phone2',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'prefix_phone2',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'suffix_phone2',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'dob_month',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'dob_day',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'dob_year',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'password',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'verify_password',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'optin1',
                    processArgs: (val) => {
                        return val === true ? val : '';
                    },
                },
                {
                    name: 'optin2',
                    processArgs: (val) => {
                        return val === true ? val : '';
                    },
                },
                {
                    name: 'submit',
                    processArgs: (val) => {
                        return 'Submit';
                    },
                },
            ],
        },
        {
            name: 'Winners',
            method: appUrl + '/winnersdata.php',
            action: 'get',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            args: [
                {
                    name: 'game_id',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'draw_number',
                    processArgs: (val) => {
                        return val;
                    },
                },
            ],
        },
        {
            name: 'Feedback',
            method: appUrl + '/feedback.php',
            action: 'post',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            args: [
                {
                    name: 'name',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'email',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'comments',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'submit',
                    processArgs: (val) => {
                        return 'Submit';
                    },
                },
                {
                    name: 'form_submitted',
                    processArgs: (val) => {
                        return 1;
                    },
                },
            ],
        },
        {
            name: 'GetGame',
            method: appUrl + '/game/game.php',
            action: 'get',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            args: [
                {
                    name: 'points',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'outcome',
                    processArgs: (val) => {
                        return val;
                    },
                },
            ],
        },
        {
            name: 'GetGameOver',
            method: appUrl + '/gameOver.php',
            action: 'get',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            args: [],
        },
        {
            name: 'ForgotPassword',
            method: appUrl + '/users/forgot_data.php',
            action: 'post',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            args: [
                {
                    name: 'email',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'submit',
                    processArgs: (val) => {
                        return 'Submit';
                    },
                },
                {
                    name: 'form_submitted',
                    processArgs: (val) => {
                        return 1;
                    },
                },
            ],
        },
        {
            name: 'GetAppVals',
            method: appUrl + '/app_vals.php',
            action: 'get',
            postBuild: (postingData, requestObj) => requestObj,
            postRequest: (err, res) => {},
            args: [],
        },
    ];
};
